import React from "react";
import Nabvar from "../common/Nabvar";
import Sidebar from "../common/Sidebar";
import History from "./coupon/History";

export default function CouponList() {

  return (
    <>
      <Sidebar />
      <Nabvar />
      <History />
    </>
  );
}
